import { FC, Fragment, memo, useEffect, useMemo } from 'react';
import { characterPoints } from './instance';
import styles from './index.module.scss';
import { useQueryGetAllRouteData } from '@/services/hooks';
import { CharacterRoutePlaceInfo, PageMode } from '@/store/types';
import { useStore } from '@/store';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';

const CharaterRouteVideo: FC = () => {
  const setMode = useStore((state) => state.setMode);
  const setRouteDetailMode = useStore((state) => state.setRouteDetailMode);

  const { data } = useQueryGetAllRouteData();
  const charaterList: any = useMemo(() => {
    if (data) {
      return data.charaterList;
    }

    return [];
  }, [data]);

  // 语音控制
  useEffect(()=>{
    driveDigitalHumanByText('千年风云，一湖诗画。在西湖边，多少文人墨客用手中一支笔，写下西湖千年盛景。“文学西湖”从1000+文学名人中，精选了16位，沿着他们的文学路线，领略他们笔下的西湖。');
  },[])

  return (
    <div className={styles.charaterRouteVideo}>
      {
        charaterList?.length ?
          <div className={styles.content}>
            {
              characterPoints.map((item) => {
                let name = '';
                const target = charaterList.find((i: CharacterRoutePlaceInfo) => {
                  if (i?.content && i.content.includes('\n')) {
                    if (i.content.split('\n')[0] === item.name) {
                      name = item.name;
                      return i;
                    }
                  }
                })

                return (
                  <Fragment key={item.name}>
                    <div
                      className={styles.character}
                      style={{
                        top: item.top,
                        left: item.left,
                      }}
                      onClick={() => {
                        if (name) {
                          // setMode(PageMode.ROUTE_CHARACTER_TRACK_SINGLE);
                          setRouteDetailMode(target?.entity_id);
                        }
                      }}
                    >
                      {/* <div className={styles.info} style={{ top: item.info.top, left: item.info.left }}>
                      <span>{item.info.label}</span>
                      {
                        item.info?.down ?
                          <div
                            className={styles.down}
                            style={{ top: item.info.down.top, left: item.info.down.left }}
                          /> :
                          <div
                            className={styles.up}
                            style={{ top: item.info.up.top, left: item.info.up.left }}
                          />
                      }
                    </div> */}
                      {
                        item?.video ?
                          <video
                            key={item.name}
                            src={item.video}
                            style={{ width: item.width }}
                            autoPlay
                            loop
                          /> :
                          <img
                            key={item.name}
                            src={item.image}
                            style={{ width: item.width, height: item.height, objectFit: 'cover' }}
                          />
                      }
                    </div>
                    <div className={styles.sign} style={{ top: item.sign.top, left: item.sign.left }}>
                      {item.name}
                    </div>
                  </Fragment>
                )
              })
            }
          </div> :
          null
      }
      <QrCode />
    </div>
  )
}

export default memo(CharaterRouteVideo);
